import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase URL ou Anon Key não configurados. Verifique as variáveis de ambiente.');
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '');

export type AuthUser = {
  id: string;
  email: string;
};

// Tipos do banco de dados
export interface Profile {
  id: string;
  full_name: string | null;
  company_name: string | null;
  price_moldura: number;
  price_gesso_liso: number;
  price_bloco: number;
  price_sanca: number;
  price_gesso_simples: number;
  price_forro_reforcado: number;
  price_dilatacao: number;
  price_reboco: number;
  price_revestimento: number;
  price_reboco_separado?: number;
  price_parede_bloco_separado?: number;
  price_revestimento_separado?: number;
  custom_services: any; // JSONB
  updated_at: string;
}

export interface BudgetDB {
  id: string;
  user_id: string;
  client_name: string;
  client_phone: string | null;
  notes: string | null;
  total_value: number;
  status: 'pendente' | 'aprovado' | 'cancelado';
  margin_loss: number;
  created_at: string;
  width?: number; // Largura
  depth?: number; // Comprimento
  height?: number; // Altura
  rooms?: any; // JSONB
}

export interface BudgetItemDB {
  id: string;
  budget_id: string;
  room_id?: string | null;
  service_type: string;
  quantity: number;
  unit_price: number;
  subtotal: number;
}
